<template>
    <a class="go-to-project" target="_blank" :href="dataStore.project.currentUrl">{{ label }}</a>
</template>

<script>

import dataStore from "../../store";

export default {

    props : {
        label : String
    },

    data() {
        return {
            dataStore,
        }
    }
};

</script>
